import { render, staticRenderFns } from "./DFInputText.vue?vue&type=template&id=41225fb5&"
import script from "./DFInputText.vue?vue&type=script&lang=js&"
export * from "./DFInputText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports